export const AUDIO_EXTENSIONS = ['mp3', 'wav', 'ogg'];
